let rgate = (pagesType, num) => {
  if (pagesType.reverse) return 0 - num;
  return num;
};

let pagesFiltered = (pagesType, filter, reverse) => {
  let pagesListFiltered = pagesType.list.sort((a, b) => {
    if (["Theme Index Template", "Your first Homepage", "Theme Product Template", "Theme Collection Template"].includes(a.title)) {
      return -1;
    }

    if (["Theme Index Template", "Your first Homepage", "Theme Product Template", "Theme Collection Template"].includes(b.title)) {
      return 1;
    }

    if ((a.type === "template-index" || a.type === "template-product" || a.type === "template-collection") && a.published) return -1;

    if ((a.type === "template-index" || a.type === "template-product" || a.type === "template-collection") && b.published) return 1;

    // if (filter.includes("date"))
    //   return reverse(pagesType, new Date(a.updated_at) <= new Date(b.updated_at) ? 1 : -1);
    // if (filter.includes("name")) return reverse(pagesType, a.title.localeCompare(b.title));
    if (filter.includes("name")) return reverse(pagesType, a.title.localeCompare(b.title));
    if (filter.includes("modified")) return reverse(pagesType, new Date(a.updated_at) <= new Date(b.updated_at) ? 1 : -1);
    if (filter.includes("published")) return reverse(pagesType, new Date(a.published_at) <= new Date(b.published_at) ? 1 : -1);

    return 1;
  });

  if (pagesType.group_query != 0) {
    pagesListFiltered = pagesListFiltered.filter(e => e.page_group_id == pagesType.group_query);
  }

  return pagesListFiltered;
};

let sortedPages = (state, type) => {
  let pagesType = state.pages[type];
  let newPagesFiltered = pagesFiltered(pagesType, pagesType.filter, rgate);
  // let start = (pagesType.pagination.page - 1) * pagesType.pagination.limit;
  let query = pagesType.query.toLowerCase() || "";
  // let typeSubItem = ["collectionpages", "productpages"];
  newPagesFiltered = newPagesFiltered.filter(item => {
    // let _item = JSON.parse(JSON.stringify(item));
    // let hasAssignLike = false;
    // if (typeSubItem.includes(type) && _item.assigns && _item.assigns.length) {
    //   hasAssignLike = _item.assigns.find(x => (x.title || "").toLowerCase().includes(query));
    //   if (hasAssignLike) return true;
    // }
    const id = item.id + "";
    return item.title.toLowerCase().includes(query) || (item?.itemsName?.toLowerCase().includes(query)) || id.includes(query);
  });
  return newPagesFiltered; //.slice(start, start + pagesType.pagination.limit);
};

let sortedAssignments = (state, type, limit, search, page) => {
  let pagesType = state.assignments[type];
  let pageLimit = pagesType.pagination.limit;
  let result = pagesType.list;
  if (limit) {
    pageLimit = limit;
  }
  let start = (pagesType.pagination.page - 1) * pageLimit;

  if (search) {
    result = result.filter(e => e.title.toLowerCase().includes(search.toLowerCase()));
  }
  if (page == 1) {
    return result.slice(start, start + pageLimit - 1);
  }
  return result.slice(start, start + pageLimit);
};

let pagesByType = (state, type) => {
  let newArr = [];
  state.pages[type].list.forEach(element => {
    if (element.title == "Theme Product Template" || element.title == "Your first Homepage" || element.title == "Theme Collection Template") {
      newArr.unshift(element);
      return;
    }
    newArr.push(element);
  });
  return newArr;
};

const getters = {
  allPages: state => {
    const types = ["subpages", "articlepages", "homepages", "productpages", "collectionpages"];
    let output = [];
    types.forEach(type => {
      if (state.pages && state.pages[type] && state.pages[type].list) output.push(...state.pages[type].list);
    });
    if (state.search.pages && state.search.pages.length)
      state.search.pages.forEach(item => {
        let ind = output.findIndex(x => x.id == item.id);
        if (ind < 0) output.push(item);
      });
    if (state.pages.recentPage && state.pages.recentPage.list && state.pages.recentPage.list.length)
      state.pages.recentPage.list.forEach(item => {
        let ind = output.findIndex(x => x.id == item.id);
        if (ind < 0) output.push(item);
      });
    return output;
  },
  loadingPages: state => {
    if (state.search.loading) return true;
    return false;
  },
  sortedSubPages: state => {
    return sortedPages(state, "subpages");
  },
  sortedArticlePages: state => {
    return sortedPages(state, "articlepages");
  },
  sortedCollectionPages: state => {
    return sortedPages(state, "collectionpages");
  },
  sortedHomePages: state => {
    return sortedPages(state, "homepages");
  },
  sortedProductPages: state => {
    return sortedPages(state, "productpages");
  },
  allSubPages: state => {
    return pagesByType(state, "subpages");
  },
  allArticlePages: state => {
    return pagesByType(state, "articlepages");
  },
  allCollectionPages: state => {
    return pagesByType(state, "collectionpages");
  },
  allHomePages: state => {
    return pagesByType(state, "homepages");
  },
  allProductPages: state => {
    return pagesByType(state, "productpages");
  },
  pageTypeStatus: state => {
    return pageType => state.pages[pageType].status;
  },
  allTemplates: state => {
    var firstList = [];
    var secondList = [];
    var templates = state.templates.list;

    for (var i = 0; i < templates.length; i++) {
      if (templates[i].tags == state.templates.tags) {
        firstList.push(templates[i]);
      } else {
        secondList.push(templates[i]);
      }
    }
    templates = firstList.concat(secondList);
    return templates;
  },
  getAssignedPublished: state => type => state.pages[type].list.find(e => e.published == true),
  getTemplate: state => id => state.templates.list.find(e => e.id === id),
  getPage: state => id => {
    let arr = [];
    const types = ["subpages", "articlepages", "homepages", "productpages", "collectionpages"];
    types.forEach(type => {
      arr.push(...pagesByType(state, type));
    });
    return arr.find(item => item.id == id);
  },
  newestItems: state => type => state.assignments.newestItems[type].list,
  getAssignments: state => ({ type, search, limit, page }) => {
    return sortedAssignments(state, type, limit, search, page);
  },
  getAssignItems: state => type => state.assignments[type].list,
  getAssignsTotal: state => type => state.assignments[type].total,
  recentPages: state => {
    return pagesByType(state, "recentPage");
  },
};

export default getters;
